module.exports = __webpack_public_path__ + "img/green_083.77cfc96c.png";